/* ГРАФИКИ */
const { default: cfgDrawBarsNew } = require('./cfgGraphics/drawBarsNew');
const $graphics = $('.js-graphics');

if ($graphics.length) {
    $graphics.each(function (index, el) {
        const $currGraphicsWrap = $(el);

        if ($currGraphicsWrap.data('type') === 'bars') {
            drawBars($currGraphicsWrap);
        }

        if ($currGraphicsWrap.data('type') === 'bars-new') {
            drawBarsNew($currGraphicsWrap);
        }

        if ($currGraphicsWrap.data('type') === 'horizontal-bars') {
            drawHorBars($currGraphicsWrap);
        }

        if ($currGraphicsWrap.data('type') === 'doughnut') {
            drawDoughnut($currGraphicsWrap);
        }

        if ($currGraphicsWrap.data('type') === 'lines') {
            drawLines($currGraphicsWrap);
        }

        if ($currGraphicsWrap.data('type') === 'combo') {
            drawCombo($currGraphicsWrap);
        }
    });
}

function drawBarsNew($currGraphics) {
    let ctx = $currGraphics.find('canvas')[0].getContext('2d');
    let currGraphicData = JSON.parse($currGraphics.find('[data-role="graphics-data"]').html())[0];
    const maxScale = $currGraphics.data('scale-max') ?  parseFloat($currGraphics.data('scale-max')) : 1.1;
    const ymax = maxScale * Math.max.apply(Math, currGraphicData.values);
    
    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics);
    }

    const { interestArray, interestArrayBonus } = conversionToInterest(
        currGraphicData
    );

    const dataSetsCfg = cfgDrawBarsNew(
        currGraphicData,
        interestArray,
        interestArrayBonus
    );


    let dataObj = {
        labels: currGraphicData.label,
        datasets: [dataSetsCfg.initial, dataSetsCfg.bonus],
    };

    new Chart(ctx, {
        type: 'bar',
        data: dataObj,
        options: {
            responsive: true,
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltips: {
                enabled: false,
                custom: customTooltip,
                callbacks: {
                    label(tooltipItem, data) {
                        const val =
                            data.datasets[tooltipItem.datasetIndex].interest[
                                tooltipItem.index
                            ];
                        let label = data.labels[tooltipItem.index] || '';
                        
                        if (label) { 
                            label += ': ';
                        };
                        
                        return label + val + '%';
                    },
                },
            },
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        ticks: {
                            fontSize: 14,
                            fontStyle: 'bold',
                            fontColor: '#1A180F',
                        },
                        gridLines: {
                            drawBorder: true,
                            drawOnChartArea: false,
                        },
                    },
                ],
                yAxes: [
                    {
                        stacked: true,
                        ticks: {
                            fontSize: 12,
                            fontStyle: 'bold',
                            fontColor: '#B6B6B6',
                            suggestedMin: 0,
                            suggestedMax: ymax,
                        },
                    },
                ],
            },
            plugins: {
                datalabels: {
                    color: '#1A180F',
                    font: {
                        weight: 'bold',
                        size: 14,
                    },
                    display: () => '',
                    formatter: function (value, context) {
                        return context.chart.data.labels[context.dataIndex];
                    },
                },
            },
        },
    });
}

function drawBars($currGraphics) {
    let ctx = $currGraphics.find('canvas')[0].getContext('2d');
    let currGraphicData = JSON.parse(
        $currGraphics.find('[data-role="graphics-data"]').html()
    )[0];
    const maxScale = $currGraphics.data('scale-max')
        ? parseFloat($currGraphics.data('scale-max'))
        : 1.1;
    const ymax = maxScale * Math.max.apply(Math, currGraphicData.values);

    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics);
    }

    let dataObj = {
        labels: currGraphicData.labels,
        datasets: [
            {
                label: currGraphicData.title,
                backgroundColor: currGraphicData.colors,
                hoverBackgroundColor: currGraphicData.colors,
                data: currGraphicData.values,
                barPercentage: 0.7,
                categoryPercentage: 0.7,
                maxBarThickness: 64,
            },
        ],
    };

    new Chart(ctx, {
        type: 'bar',
        data: dataObj,
        options: {
            responsive: true,
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltips: {
                enabled: false,
                custom: customTooltip,
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            fontSize: 14,
                            fontStyle: 'bold',
                            fontColor: '#1A180F',
                        },
                        gridLines: {
                            drawBorder: true,
                            drawOnChartArea: false,
                        },
                    },
                ],
                yAxes: [
                    {
                        ticks: {
                            fontSize: 12,
                            fontStyle: 'bold',
                            fontColor: '#B6B6B6',
                            suggestedMin: 0,
                            suggestedMax: ymax,
                        },
                    },
                ],
            },
            plugins: {
                datalabels: {
                    color: '#1A180F',
                    font: {
                        weight: 'bold',
                        size: 14,
                    },
                    display: function () {
                        return '';
                    },
                    formatter: function (value, context) {
                        return context.chart.data.labels[context.dataIndex];
                    },
                },
            },
        },
    });
}


function drawLines($currGraphics) {
    let ctx = $currGraphics.find('canvas')[0].getContext('2d');
    let currGraphicData = JSON.parse($currGraphics.find('[data-role="graphics-data"]').html())[0];
    let graphicData = [];
    const maxScale = $currGraphics.data('scale-max') ?  parseFloat($currGraphics.data('scale-max')) : 1.1;
    const ymax = maxScale * Math.max.apply(Math, currGraphicData.values);

    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics);
    }

    graphicData.push({
        data: currGraphicData.values,
        borderColor: currGraphicData.colors,
        pointBackgroundColor: currGraphicData.colors,
        pointBorderColor: 'rgba(255, 255, 255, 1)',
        pointBorderWidth: 2,
        pointHoverBorderWidth: 4,
        pointRadius: 8,
        pointHoverRadius: 8,
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
    });

    let dataObj = {
        labels: currGraphicData.labels,
        datasets: graphicData
    };

    new Chart(ctx, {
        type: 'line',
        data: dataObj,
        options: {
            responsive: true,
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltips: {
                enabled: false,
                custom: customTooltip
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontSize: 14,
                        fontStyle: 'bold',
                        fontColor: '#1A180F'
                    },
                    gridLines: {
                        drawBorder: true,
                        drawOnChartArea: false
                    }
                }],
                yAxes: [{
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: ymax
                    },
                }]
            },
            plugins: {
                datalabels: {
                    color: '#1A180F',
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    display: function () {
                        return '';
                    }
                }
            }
        }
    });
}

function drawHorBars($currGraphics) {
    let ctx = $currGraphics.find('canvas')[0].getContext('2d');
    let currGraphicData = JSON.parse($currGraphics.find('[data-role="graphics-data"]').html())[0];
    const maxScale = $currGraphics.data('scale-max') ?  parseFloat($currGraphics.data('scale-max')) : 1.1;
    const ymax = maxScale * Math.max.apply(Math, currGraphicData.values);

    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics);
    }

    let dataObj = {
        labels: currGraphicData.labels,
        datasets: [{
            label: currGraphicData.title,
            hoverBackgroundColor: currGraphicData.colors,
            backgroundColor: currGraphicData.colors,
            data: currGraphicData.values,
            maxBarThickness: 24
        }]
    };



    new Chart(ctx, {
        type: 'horizontalBar',
        data: dataObj,
        options: {
            responsive: true,
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltips: {
                enabled: false,
                custom: customTooltip
            },
            scales: {
                xAxes: [{
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: ymax
                    },
                    gridLines: {
                        drawBorder: true,
                        drawOnChartArea: false
                    }
                }],
                yAxes: [{
                    display: false
                }]
            },
            plugins: {
                datalabels: {
                    color: '#1A180F',
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    display: function () {
                        return '';
                    }
                }
            }
        }
    });
}


function drawCombo($currGraphics) {
    let ctx = $currGraphics.find('canvas')[0].getContext('2d');
    let currGraphicData = JSON.parse($currGraphics.find('[data-role="graphics-data"]').html())[0];
    const maxScale = $currGraphics.data('scale-max') ? parseFloat($currGraphics.data('scale-max')) : 1.1;
    const ymax = maxScale * Math.max.apply(Math, currGraphicData.values);

    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics, true);
    }


    let dataObj = {
        labels: currGraphicData.labels,
        datasets: [{
            label: currGraphicData.titles[0],
            data: currGraphicData.values,
            backgroundColor: currGraphicData.colorBar,
            hoverBackgroundColor: currGraphicData.colorBar,
            barPercentage: 0.7,
            categoryPercentage: 0.7,
            maxBarThickness: 64,
            order: 1

        }, {
            label: currGraphicData.titles[1],
            data: currGraphicData.values,
            borderColor: currGraphicData.colorLine,
            type: 'line',
            pointBackgroundColor: currGraphicData.colorLine,
            pointBorderColor: 'rgba(255, 255, 255, 1)',
            pointBorderWidth: 2,
            pointHoverBorderWidth: 4,
            pointRadius: 8,
            pointHoverRadius: 8,
            fill: false,
            cubicInterpolationMode: 'monotone',
            tension: 0.1,
            order: 0
        }]
    };

    new Chart(ctx, {
        type: 'bar',
        data: dataObj,
        options: {
            responsive: true,
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltips: {
                enabled: false,
                custom: customTooltip
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontSize: 14,
                        fontStyle: 'bold',
                        fontColor: '#1A180F'
                    },
                    gridLines: {
                        drawBorder: true,
                        drawOnChartArea: false
                    }
                }],
                yAxes: [{
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: ymax
                    }
                }]
            },
            plugins: {
                datalabels: {
                    color: currGraphicData.colorLine,
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    align: 'start',
                    offset: -30,
                    formatter: function(value, context) {
                        return context.datasetIndex === 0 ? '' : currGraphicData.valuesLines[context.dataIndex];
                    }
                }
            }
        }
    });
}

function drawDoughnut($currGraphics) {
    let $canvas = $currGraphics.find('canvas');
    let currGraphicData = JSON.parse($currGraphics.find('[data-role="graphics-data"]').html())[0];

    if ($currGraphics.is('[data-legend]')) {
        generateLegend(currGraphicData, $currGraphics);
    }

    let config = {
        type: 'doughnut',
        data: {
            datasets: [{
                data: currGraphicData.values,
                backgroundColor: currGraphicData.colors,
                borderWidth: 0,
                label: ''
            }],
            labels: currGraphicData.labels,
            datalabels: {
                anchor: 'center',
                backgroundColor: null,
                borderWidth: 0
            }
        },
        options: {
            responsive: true,
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltips: {
                enabled: false,
                backgroundColor: '#fff',
                titleFontFamily: '',
                titleFontSize: 14,
                caretSize: 0,
                cornerRadius: 15,
                displayColors: false,
                bodyFontColor: '#F7AF29',
                xPadding: 12,
                yPadding: 8,
                borderWidth: 1,
                borderColor: '#c4c4c4',
                custom: customTooltip
            },
            plugins: {
                // метки на секторах
                datalabels: {
                    color: '#1A180F',
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    formatter: function(value) {
                        return value + '%';
                    }
                },
                // метки в цетре круга
                doughnutlabel: {
                    labels: [{
                        text: $currGraphics.data('total-value') ? $currGraphics.data('total-value') : '',
                        font: {
                            family: 'Co Headline Corp',
                            size: 36
                        },
                        color: '#1A180F'
                    }, {
                        text:  $currGraphics.data('total-label') ? $currGraphics.data('total-label') : '',
                        font: {
                            family: 'Inter',
                            size: 14,
                            weight: 'bold'
                        },
                        color: '#1A180F'
                    }]
                }

            }
        }
    };

    let ctx = $canvas[0].getContext('2d');
    new Chart(ctx, config);
}

function generateLegend(data, graphicWrap, isComboType) {
    if (data.valuesBonus) {
        const { interestArray, interestArrayBonus } = conversionToInterest(
            data
        );
        data.colors = data.colors.concat(data.colorsBonus);
        data.labels = interestArray.concat(interestArrayBonus);
    }

    let legendValues = isComboType ? data.titles : data.labels;
    let legendColors = isComboType ? [data.colorBar, data.colorLine] : data.colors;

    if (data.colors && data.colors.length === 1) {
        return false;
    }

    graphicWrap.append('<div class="legend js-legend"></div>');

    let legendData = '';
    let $currLegend = graphicWrap.find('.js-legend');

    for (let i = 0; i < legendValues.length; i++) {
        legendData += `<div class="legend-item">
            <div class="legend-item__back" style="background-color: ${legendColors[i]}"></div>
            <div class="legend-item__title">${legendValues[i]}</div>
        </div>`;
    }

    $currLegend.append(legendData);
}

function customTooltip(tooltipModel) {
    let $currentGraphicWrap = $(this._chart.canvas).closest('.js-graphics-wrap');
    let $currentGraphic = $currentGraphicWrap.closest('.js-graphics');
    let tooltipEl = document.getElementById('chartjs-tooltip');
    let graphicType = $currentGraphic.data('type') === 'combo' ? 'combo' : this._chart.config.type;
    let gData = JSON.parse($currentGraphicWrap.siblings('[data-role="graphics-data"]').html())[0];

    // Create element on first render
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.innerHTML = `<div class="graphic-tooltip"></div>`;
        document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    function getBody(bodyItem) {
        return bodyItem.lines;
    }

    let tableRoot = tooltipEl.querySelector('.graphic-tooltip');

    // Set Text
    if (tooltipModel.body) {
        let bodyLines = tooltipModel.body.map(getBody);
        let innerHtml = '';
        let text = [];

        bodyLines.forEach(function(body) {
            text.push(body);
        });

        innerHtml = text.join(' ');
        tableRoot.classList.remove('bar', 'doughnut', 'horizontalBar', 'combo');
        tableRoot.classList.add(graphicType);
        tableRoot.innerHTML = innerHtml;
    }

    if (gData.tooltips && gData.tooltips.length) {
        tableRoot.innerHTML = gData.tooltips[tooltipModel.dataPoints[0].index];
    }

    // `this` will be the overall tooltip
    var position = this._chart.canvas.getBoundingClientRect();

    // Display, position, and set styles for font
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + (window.pageYOffset + tooltipModel.caretY - ((graphicType === 'horizontalBar') ? 0 : 35)) + 'px';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.opacity = 1;
}

function conversionToInterest(graphicData) {
    const maxValInArray = Math.max.apply(
        Math,
        graphicData.values.concat(graphicData.valuesBonus)
    );
    const interestArray = graphicData.interest.map((item, index) => {
        return parseFloat(((item / 100) * maxValInArray).toFixed(2));
    });

    const interestArrayBonus = graphicData.interestBonus.map((item, index) => {
        return parseFloat(((item / 100) * maxValInArray).toFixed(2));
    });

    return {
        interestArray,
        interestArrayBonus
    };
}


// WEBPACK FOOTER //
// ./_src/js/Graphics.js